module.exports = __webpack_public_path__ + "media/images/lb/638-ca046c7db8121b85aa914fd541eb7ef5.svg";